import { Button, Flex } from "@chakra-ui/react";

export type StatusOption = {
  value: string;
  label: string;
};

export type StatusFilterProps = {
  statuses: StatusOption[];
  value: string;
  onChange: (value: string) => void;
};

export function StatusFilter({ statuses, value, onChange }: StatusFilterProps) {
  return (
    <Flex>
      {statuses.map((status, index) => (
        <Button
          key={status.value}
          onClick={() => onChange(status.value)}
          size="sm"
          variant="outline"
          bg={value === status.value ? "#EFE6FF" : "transparent"}
          color={value === status.value ? "#6200FF" : "#6C6B6E"}
          borderColor={value === status.value ? "#6200FF" : "#D4D4D4"}
          borderWidth="1px"
          position="relative"
          ml={index > 0 ? "-1px" : "0"}
          zIndex={value === status.value ? 1 : 0}
          borderRadius={
            index === 0 ? "8px 0 0 8px" : index === statuses.length - 1 ? "0 8px 8px 0" : "0"
          }
          px={status.value.toLowerCase() === "all" ? "24px" : undefined}
          _hover={{
            bg: value === status.value ? "#EFE6FF" : "transparent",
            borderColor: value === status.value ? "#6200FF" : "#D4D4D4",
            color: value === status.value ? "#6200FF" : "#6C6B6E",
          }}
        >
          {status.label}
        </Button>
      ))}
    </Flex>
  );
}
